/**
 * Paramedie Gelderse Vallei
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import { Swiper } from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

Swiper.use([Autoplay, Navigation]);

/**
 * Swiper controller.
 */
export default class extends Controller {
  static targets = ['wrapper'];

  static values = {
    options: Object,
  };

  swiper;

  /**
   * Init.
   */
  initialize() {
    this.swiper = new Swiper(this.wrapperTarget, {
      slidesPerView: 'auto',
      ...this.optionsValue,
    });
  }

  /**
   * Mount.
   */
  connect() {
    this.swiper.enable();
  }

  /**
  * Disconnect swiper.
  */
  disconnect() {
    this.swiper.destroy(true);
    this.swiper = undefined;
  }
}
